module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero.9b3f3c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/time-attendance/fullscreen-image_hero.png
// module id = ShPK
// module chunks = 0